// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-view-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: #ffffff;
}
.error-view-container .error-view {
  position: absolute;
  left: 50%;
  top: 50%;
  max-width: 920px;
  width: 100%;
  line-height: 1.4;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
  transform: translate(-50%, -50%);
}
.error-view-container .error-view .error-view-code {
  position: absolute;
  height: 100px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}
.error-view-container .error-view .error-view-code h1 {
  font-family: maven pro, sans-serif;
  color: #ececec;
  font-weight: 900;
  font-size: 276px;
  margin: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.error-view-container .error-view .error-view-header {
  font-family: maven pro, sans-serif;
  font-size: 46px;
  color: #000;
  font-weight: 900;
  text-transform: uppercase;
  margin: 0;
}
.error-view-container .error-view .error-view-content {
  margin: 15px auto auto auto;
  font-size: 14px;
  max-width: 700px;
  line-height: 26px;
  font-family: maven pro, sans-serif;
  color: #000;
  font-weight: 400;
  text-transform: uppercase;
}
.error-view-container .error-view .error-view-content a {
  color: #000;
  font-weight: bold;
}

@media only screen and (max-width: 480px) {
  .error-view .error-view-code h1 {
    font-size: 162px;
  }
  .error-view h2 {
    font-size: 26px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/errors/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,gCAAA;AACJ;AACI;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;EAGA,2BAAA;EACA,WAAA;AACN;AACM;EACE,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EAGA,gCAAA;AACR;AAGI;EACE,kCAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;AADN;AAII;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AAFN;AAIM;EACE,WAAA;EACA,iBAAA;AAFR;;AAUA;EACE;IACE,gBAAA;EAPF;EASA;IACE,eAAA;EAPF;AACF","sourcesContent":[".error-view-container {\r\n  position: relative;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  background-color: #ffffff;\r\n\r\n  .error-view {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    max-width: 920px;\r\n    width: 100%;\r\n    line-height: 1.4;\r\n    text-align: center;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n\r\n    .error-view-code {\r\n      position: absolute;\r\n      height: 100px;\r\n      top: 0;\r\n      left: 50%;\r\n      -webkit-transform: translateX(-50%);\r\n      -ms-transform: translateX(-50%);\r\n      transform: translateX(-50%);\r\n      z-index: -1;\r\n\r\n      h1 {\r\n        font-family: maven pro, sans-serif;\r\n        color: #ececec;\r\n        font-weight: 900;\r\n        font-size: 276px;\r\n        margin: 0;\r\n        position: absolute;\r\n        left: 50%;\r\n        top: 50%;\r\n        -webkit-transform: translate(-50%, -50%);\r\n        -ms-transform: translate(-50%, -50%);\r\n        transform: translate(-50%, -50%)\r\n      }\r\n    }\r\n\r\n    .error-view-header {\r\n      font-family: maven pro, sans-serif;\r\n      font-size: 46px;\r\n      color: #000;\r\n      font-weight: 900;\r\n      text-transform: uppercase;\r\n      margin: 0\r\n    }\r\n\r\n    .error-view-content {\r\n      margin: 15px auto auto auto;\r\n      font-size: 14px;\r\n      max-width: 700px;\r\n      line-height: 26px;\r\n      font-family: maven pro, sans-serif;\r\n      color: #000;\r\n      font-weight: 400;\r\n      text-transform: uppercase;\r\n\r\n      a {\r\n        color: #000;\r\n        font-weight: bold;\r\n      }\r\n    }\r\n  }\r\n\r\n}\r\n\r\n\r\n@media only screen and (max-width:480px) {\r\n  .error-view .error-view-code h1 {\r\n    font-size: 162px\r\n  }\r\n  .error-view h2 {\r\n    font-size: 26px\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
